// Menu viewer: full screen on phones, a centred 95vw × 85dvh panel from 640px.
// Doubled selectors outrank the Modal's own full-screen rules. The dialog is
// portalled out of the block, so each site's palette is set on it directly.
.groups {
    --mv-surface: oklch(98.5% 0.008 85deg);
    --mv-pages: oklch(95.5% 0.012 84deg);
    --mv-muted: oklch(47% 0.015 270deg);
    --mv-border: oklch(90% 0.018 82deg);
}

.happyHour {
    --mv-surface: oklch(98.5% 0.006 95deg);
    --mv-pages: oklch(95% 0.015 90deg);
    --mv-muted: oklch(47% 0.03 255deg);
    --mv-border: oklch(90% 0.015 90deg);
}

.dialog.dialog {
    background-color: var(--mv-surface);
    display: flex;
    flex-direction: column;
    font-family:
        nobel, "Nobel Regular", "Helvetica Neue", helvetica, arial, sans-serif;
    overflow: hidden;

    @media (min-width: 640px) {
        border-radius: 8px;
        height: 85dvh;
        inset: 50% auto auto 50%;
        max-width: 56rem;
        transform: translate(-50%, -50%);
        width: 95vw;
    }
}

.dialogOverlay {
    background-color: rgb(0 0 0 / 50%);
}

.dialogClose.dialogClose {
    position: absolute;
    right: 0.5rem;
    top: 0.25rem;
}

.bar {
    align-items: center;
    border-bottom: 1px solid var(--mv-border);
    display: flex;
    flex: none;
    gap: 0.5rem;
    height: 3rem;
    padding: 0 3.5rem 0 1rem;
}

.title {
    font-size: 1rem;
    font-weight: 600;
    margin: 0;
}

.link {
    color: var(--mv-muted);
    font-size: 0.75rem;
    margin-left: auto;
    text-decoration: none;

    &:hover {
        color: #db0e0a;
    }
}

.pages {
    background-color: var(--mv-pages);
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    padding: 0.75rem;

    @media (min-width: 640px) {
        padding: 1.25rem;
    }
}

.page {
    background-color: #ffffff;
    border-radius: 6px;
    box-shadow:
        0 1px 2px rgb(0 0 0 / 6%),
        0 12px 32px rgb(0 0 0 / 10%);
    display: block;
    height: auto;
    margin: 0 auto 0.75rem;
    max-width: 48rem;
    width: 100%;
}

.srOnly {
    border: 0;
    clip-path: inset(50%);
    height: 1px;
    margin: -1px;
    overflow: hidden;
    padding: 0;
    position: absolute;
    white-space: nowrap;
    width: 1px;
}
